import Icon from '@/components/UI/Icon/Icon';
import { IconTightViewBoxes, INLINE_ICON_STYLE } from '@/constants/Icons';
import { BENCHLING_DELEGATED_TOOLTIP } from '@/support/benchlingLink/BenchlingLink.utils';
import cn from 'classnames';
import type { FC } from 'react';

interface BenchlingDelegatedIconProps {
  className?: string;
  testId?: string;
}

export const BenchlingDelegatedIcon: FC<BenchlingDelegatedIconProps> = ({
  className,
  testId = 'benchling-delegated-icon',
}) => (
  <Icon
    icon="jeffy_p_circle"
    tooltip={BENCHLING_DELEGATED_TOOLTIP}
    className={cn('blue', className)}
    style={INLINE_ICON_STYLE}
    width="1em"
    height="1em"
    viewBox={IconTightViewBoxes.jeffy_p_circle}
    testId={testId}
  />
);
